import { render, staticRenderFns } from "./serviceNitoceManage.vue?vue&type=template&id=31cd2c21&scoped=true&"
import script from "./serviceNitoceManage.vue?vue&type=script&lang=js&"
export * from "./serviceNitoceManage.vue?vue&type=script&lang=js&"
import style0 from "./serviceNitoceManage.vue?vue&type=style&index=0&id=31cd2c21&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cd2c21",
  null
  
)

export default component.exports